export default{start:(withCPU=false,withMonitorView=false)=>{},stop:()=>{},addListener:()=>({remove:()=>{}})};